import routes from '@/constants/routes';
import { FooterLink } from '../enums';

const CONTACT_SUPPORT_MAIL_TO = 'mailto:help@bodecanada.com?subject=I%20need%20help%20logging%20in';

export const FooterLinkUrl = {
  [FooterLink.PrivacyPolicy]: routes.privacyPolicy,
  [FooterLink.TermsPolicy]: routes.termsOfService,
  [FooterLink.ContactSupport]: CONTACT_SUPPORT_MAIL_TO,
};

export default {
  FooterLinkUrl,
};
